import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { AllSpecSheetResponseModel, SpecSheetResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository,Raw,getConnection, getManager } from "typeorm";
import { Alias } from 'typeorm/query-builder/Alias';
import { SpecSheetAdpater } from './dto/spec-sheet.adapter';
import { SpecSheetDto } from './dto/spec-sheet.dto';
import { SpecSheet } from './dto/spec-sheet.entity';
import { SpecSheetRequest } from './dto/specsheet-request';

@Injectable()

export class SpecSheetService{
    constructor(
      private logService:LogsService,
        @InjectRepository(SpecSheet)
        private specsheetRepository: Repository<SpecSheet>,
        private specSheetAdapter: SpecSheetAdpater
    ){}
/**
     * get specsheet details
     * @param Specsheet 
     * @param isUpdate 
     * @param request 
     */
    // @LogActions({isAsync: true})
    //SkuCodeId:number;
    async getSpecSheetDetailsWithoutRelations(customerId: number,brandId:number,SkuCodeId:number): Promise<SpecSheet> {
        // tslint:disable-next-line: typedef
        const SpecsheetResponse = await this.specsheetRepository.findOne({
          where: {customerId: Raw(alias => `customer_id = '${customerId}'`) ,brandId: Raw(alias =>`brand_id = '${brandId}'` ),skuCodeId: Raw(alias => `sku_code_id = '${SkuCodeId}'`)},
        });
        console.log(SpecsheetResponse,'duplicate')
        if (SpecsheetResponse) {
          return SpecsheetResponse;
        } else {
          return null;
        }
      }
      async createSpecSheet(specsheetDTO: SpecSheetDto, isUpdate: boolean): Promise<SpecSheetResponseModel> {
        try {
            let previousValue
            // to check whether Customer exists with the passed  Customer  or not. if isUpdate is false, a check will be done whether a record with the passed Customer is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Customer  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            console.log(isUpdate);
            if (!isUpdate) {
                const EndCustomerEntity = await this.getSpecSheetDetailsWithoutRelations(specsheetDTO.customerId,specsheetDTO.brandId,specsheetDTO.skuCodeId);
                if (EndCustomerEntity) {
                    throw new SpecSheetResponseModel(false,11104, 'combination already exists');
                }
            }
           else{
            const certificatePrevious = await this.specsheetRepository.findOne({where:{specSheetId:specsheetDTO.specSheetId}})
            previousValue = certificatePrevious.customerId+' , '+certificatePrevious.brandId
           }
            const convertedspecsheetntity: SpecSheet = this.specSheetAdapter.convertDtoToEntity(specsheetDTO, isUpdate);
            const savedSpecsheetEntity: SpecSheet = await this.specsheetRepository.save(
              convertedspecsheetntity
            );
            
            const savedSpecSheetDto: SpecSheetDto = this.specSheetAdapter.convertEntityToDto(savedSpecsheetEntity);
            console.log(savedSpecSheetDto,'save')
            if (savedSpecSheetDto) {
                let present = savedSpecSheetDto.customerId+" , "+savedSpecSheetDto.brandId
                // generating resposnse
                const response = new SpecSheetResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Data Updated Successfully' : 'Data Created Successfully', savedSpecSheetDto);
             
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Data Updated Successfully': 'Data Created Successfully'
            const userName = isUpdate? savedSpecSheetDto.updatedUser :savedSpecSheetDto.createdUser;
                const newLogDto = new LogsDto(1,name, 'SpecSheet', savedSpecSheetDto.specSheetId, true, displayValue,userName,previousValue,present)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                console.log(response,'@@@')
                return response;
            } else {
                throw new SpecSheetResponseModel(false,11106, 'SpecSheet while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    

  

      async getAllSpecSheetDetails(req?:UserRequestDto): Promise<AllSpecSheetResponseModel> {        
        try {
          const manager = getManager();
          let query='SELECT customer_id AS customerId,brand_id AS brandId,sc.sku_code_id AS skuCodeId ,s.variant_code AS variantname,brand_name AS brand,c.client_name AS clientname,sc.spec_sheet_id AS specSheetId,sc.file_name AS fileName,sc.file_path AS filePath,sc.is_active AS isActive,sc.created_at AS createdAt,sc.created_user AS createdUser,sc.updated_at AS updatedAt,sc.updated_user AS updatedUser,sc.version_flag AS versionFlag FROM spec_sheet sc LEFT JOIN customers c ON c.cust_id = sc.customer_id  LEFT JOIN master_brands mb ON mb.master_brand_id = sc.brand_id LEFT JOIN sku_codes s ON s.sku_code_id = sc.sku_code_id ORDER BY c.client_name';
        const result: SpecSheet[] = await manager.query(query)
        if (result) {
          const response = new AllSpecSheetResponseModel(true, 1111, "Data retreived sucesssfuly", result)
          if(req?.createdUser){
            const newLogDto = new LogsDto(1,'view', 'SpecSheet', 0, true, 'Data retreived sucesssfuly',req.createdUser,'','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res); 
          }
       
          return response
        } else {
          return new AllSpecSheetResponseModel(false, 1111, "Error occure")
  
        }
  
      } catch (err) {
        return err;
      }
      }


      async getAllActiveSpecSheetDetails(): Promise<AllSpecSheetResponseModel> {
        // const page: number = 1;
        try {
            const SpecSheetDto: SpecSheetDto[] = [];
            //retrieves all companies
            const SpecSheetEntities: SpecSheet[] = await this.specsheetRepository.find({ order: { 'specSheetId': 'ASC' },where:{isActive:true},
           });
         console.log(SpecSheetEntities)
            if (SpecSheetEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                SpecSheetEntities.forEach(specsheetEntity => {
                    const convertedSpecsheetDto: SpecSheetDto = this.specSheetAdapter.convertEntityToDto(
                        specsheetEntity
                      
                    );
                    SpecSheetDto.push(convertedSpecsheetDto);
                });
                const response = new AllSpecSheetResponseModel(true, 11108, "SpecSheet Details retrieved successfully", SpecSheetDto);
                return response;
            } else {
                throw new SpecSheetResponseModel(false,99998, 'Data not found'); SpecSheetDto
            }
        } catch (err) {
            return err;
        }
    }


    async getSpecsheetdetailsById(specSheetId: number): Promise<SpecSheet> {
        //  console.log(employeeId);
            const Response = await this.specsheetRepository.findOne({
            where: {specSheetId: specSheetId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
  
  
    
    async activateOrDeactivateSpecSheetDetails(specSheetReq: SpecSheetRequest): Promise<SpecSheetResponseModel> {
        try {
            const SpecSheetExists = await this.getSpecsheetdetailsById(specSheetReq.specSheetId);
            if (SpecSheetExists) {
                if (specSheetReq.versionFlag !== SpecSheetExists.versionFlag) {
                    throw new SpecSheetResponseModel(false,10113, 'Someone updated the current SpecSheet information.Refresh and try again');
                } else {
                    
                        const specsheetStatus =  await this.specsheetRepository.update(
                            { specSheetId: specSheetReq.specSheetId },
                            { isActive: specSheetReq.isActive,updatedUser: specSheetReq.updatedUser });
                       
                        if (SpecSheetExists.isActive) {
                            if (specsheetStatus.affected) {
                                const SpecsheetResponse: SpecSheetResponseModel = new SpecSheetResponseModel(true, 10115, 'SpecsheetDetails is de-activated successfully');
                                return SpecsheetResponse;
                            } else {
                                throw new SpecSheetResponseModel(false,10111, 'SpecsheetDetails is already deactivated');
                            }
                        } else {
                            if (specsheetStatus.affected) {
                                const specSheetResponse: SpecSheetResponseModel = new SpecSheetResponseModel(true, 10114, 'Specsheetdetails is activated successfully');
                                return specSheetResponse;
                            } else {
                                throw new SpecSheetResponseModel(false,10112, 'SpecsheetDetails is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new SpecSheetResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getActiveSpecSheetById(Req: SpecSheetRequest): Promise<SpecSheetResponseModel> {
        try {
          //retrieves all companies
          const SpecsheetEntities: SpecSheet = await this.specsheetRepository.findOne({
              where:{specSheetId:Req.specSheetId}
              });
              
              const specsheetData: SpecSheetDto = this.specSheetAdapter.convertEntityToDto(SpecsheetEntities);
              if (specsheetData) {
                  const response = new SpecSheetResponseModel(true, 11101 , 'SpecSheet retrived Successfully',SpecsheetEntities);
                  return response;
              }
              else{
                  throw new SpecSheetResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          return err;
      }
    }

    async updatePath(filePath: string,filename:string,specSheetId: number): Promise<FileUploadResponse> {
        try{
            const filePathUpdate = await this.specsheetRepository.update(
                { specSheetId: specSheetId },
                { filePath: filePath ,fileName:filename},
               
              );
              if (filePathUpdate.affected > 0) {
                return new FileUploadResponse( true, 11, 'uploaded successfully',filePath);
              }
              else{
                return new FileUploadResponse( false, 11, 'uploaded failed',filePath);
              }
        }
        catch(error){   
            console.log(error); 
        }
      }

}